export const TaggingSettingService = Symbol.for('TaggingSettingService');
